import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { px2rem, B4Bold, ThemeMode, B3Bold, GroupProfileImage, SkeletonBox } from '@moim/common';
import styled, { css } from 'styled-components';

var Grid = styled.div.withConfig({
  displayName: "Grid",
  componentId: "sc-awr4cw-0"
})(["display:grid;grid-template-columns:repeat(3,1fr);gap:", ";margin-top:", ";margin-bottom:", ";"], px2rem(8), px2rem(8), px2rem(8));
var GroupName = styled(B4Bold).withConfig({
  displayName: "GroupName",
  componentId: "sc-awr4cw-1"
})(["text-align:center;color:", ";"], function (props) {
  return props.theme.colorV2.colorSet.grey800;
});
var ChildMoimGroupTitleWrapper = styled.div.withConfig({
  displayName: "ChildMoimGroupTitleWrapper",
  componentId: "sc-awr4cw-2"
})(["padding:", " ", " ", " ", ";"], px2rem(20), px2rem(16), px2rem(8), px2rem(4));
var GroupCard = styled.div.withConfig({
  displayName: "GroupCard",
  componentId: "sc-awr4cw-3"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;height:", ";gap:", ";padding:", ";box-sizing:border-box;border-radius:", ";cursor:pointer;background-color:", ";", ""], px2rem(144), px2rem(8), px2rem(12), px2rem(10), function (props) {
  return props.theme.colorV2.colorSet.grey50;
}, function (props) {
  return props.isSelected && css(["background-color:", ";border:", " solid ", ";", "{color:", ";}"], function (props) {
    return props.theme.themeMode.mode === ThemeMode.LIGHT ? props.theme.colorV2.colorSet.grey400 : props.theme.colorV2.colorSet.grey500;
  }, px2rem(1), function (props) {
    return props.theme.themeMode.mode === ThemeMode.LIGHT ? props.theme.colorV2.colorSet.grey300 : props.theme.colorV2.colorSet.grey1000;
  }, GroupName, function (props) {
    return props.theme.colorV2.colorSet.white1000;
  });
});
var SubgroupSelect = function SubgroupSelect(_ref) {
  var groups = _ref.groups,
    onSelect = _ref.onSelect,
    selected = _ref.selected,
    readOnly = _ref.readOnly;
  return jsx(Fragment, {
    children: groups !== undefined ? groups === null || groups === void 0 ? void 0 : groups.map(function (group) {
      return jsxs("div", {
        children: [(groups === null || groups === void 0 ? void 0 : groups.length) > 1 && jsx(ChildMoimGroupTitleWrapper, {
          children: jsx(B3Bold, {
            children: group.childMoimGroup.title
          })
        }), jsx(Grid, {
          children: group.moims.map(function (moim) {
            return jsxs(GroupCard, {
              isSelected: Boolean(selected === null || selected === void 0 ? void 0 : selected.includes(moim.id)),
              onClick: function onClick() {
                return readOnly ? undefined : onSelect(moim.id, moim.name);
              },
              children: [jsx(GroupProfileImage, {
                icon: moim.icon,
                size: "xl",
                title: moim.name
              }), jsx(GroupName, {
                children: moim.name
              })]
            }, moim.id);
          })
        })]
      }, group.childMoimGroup.id);
    }) : jsxs(Grid, {
      children: [jsx(SkeletonBox, {
        width: "100%",
        height: px2rem(144)
      }), jsx(SkeletonBox, {
        width: "100%",
        height: px2rem(144)
      }), jsx(SkeletonBox, {
        width: "100%",
        height: px2rem(144)
      }), jsx(SkeletonBox, {
        width: "100%",
        height: px2rem(144)
      }), jsx(SkeletonBox, {
        width: "100%",
        height: px2rem(144)
      }), jsx(SkeletonBox, {
        width: "100%",
        height: px2rem(144)
      })]
    })
  });
};

export { SubgroupSelect };
